import { Tabs } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const sizeTabPosition = 1170

export default function PathTabs({ basePath, titlePath, items, onChange, defaultKey=null }) {
    const [activeKey,setActiveKey] = useState("")
    const location = useLocation()
    const navigate = useNavigate()
    const pathName = location.pathname.replace(`${basePath}/`,"").replace(basePath,"")
    const itemKeys = useMemo(()=>items.map(item=>({key:item.key,label:item.label})),[items])
    const [tabPosition, setTabPosition] = useState(window.innerWidth > sizeTabPosition ? "left" : "top")

    useEffect(()=>{
        const resizeChangePosition = ()=>{
            if (window.innerWidth > sizeTabPosition && tabPosition === "top") {
                setTabPosition("left")
            } else if (window.innerWidth <= sizeTabPosition && tabPosition === "left") {
                setTabPosition("top")
            }
        }

        window.addEventListener("resize",resizeChangePosition)
        return ()=>window.addEventListener("resive",resizeChangePosition)
    },[tabPosition])

    useEffect(()=>{
        for (const item of itemKeys) {
            var { key, label } = item
            label = typeof label === "object" 
            ? React.Children.toArray(label.props.children).filter(child => typeof child === 'string').join('') 
            : label
            const regexPattern = new RegExp(`^${key}(/.+)*$`);
            if (regexPattern.test(pathName)) {
                setActiveKey(key)
                document.title = `${titlePath ? `${titlePath} - ` : ""}${label}`
                return;
            }
        }
        if (defaultKey !== null) {
            navigate(`${basePath}/${defaultKey}`)
            return;
        }
        navigate(`${basePath}/${itemKeys[0].key}`)
    },[pathName,itemKeys,basePath,navigate,titlePath,defaultKey])

    const itemConvert = useMemo(()=>items.map(item=>({...item,children: React.cloneElement(item.children,{open: activeKey === item.key})})),[items,activeKey])

    return <Tabs 
        activeKey={activeKey}
        onChange={activeKey=>{
            navigate(`${basePath}/${activeKey}`)
            if (onChange) {
                onChange(activeKey)
            }
        }}
        tabPosition={tabPosition}
        items={itemConvert}
    />
}
